var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "event-reg-form residence-form"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('section', {
    staticClass: "col-md-6 pr-lg-5"
  }, [_c('p', {
    staticClass: "residence-info-text"
  }, [_vm._v(" Please enter the accurate residential address where you are physically residing and competing at the time of event participation. ")]), _c('div', {
    staticClass: "input-field form-group"
  }, [_c('vue-tel-input', {
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.submitted && (_vm.getError('residencePhone') || !_vm.phone.valid)
    },
    on: {
      "input": _vm.validatePhone,
      "country-changed": _vm.countryChanged
    },
    model: {
      value: _vm.form.residencePhone,
      callback: function ($$v) {
        _vm.$set(_vm.form, "residencePhone", $$v);
      },
      expression: "form.residencePhone"
    }
  }), _vm._m(0), _vm.submitted && (_vm.getError('residencePhone') || !_vm.phone.valid) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" Please enter a valid contact number ")]) : _vm._e()], 1), _c('div', {
    staticClass: "select-field form-group"
  }, [_vm._m(1), _c('v-select', {
    staticClass: "style-chooser",
    attrs: {
      "label": "name",
      "options": _vm.countriesData,
      "clearable": false,
      "placeholder": "Select your current country"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function (_ref) {
        var emoji = _ref.emoji,
          name = _ref.name;
        return [_vm._v(" " + _vm._s(emoji) + " " + _vm._s(name) + " ")];
      }
    }, {
      key: "selected-option",
      fn: function (_ref2) {
        var emoji = _ref2.emoji,
          name = _ref2.name;
        return [_vm._v(" " + _vm._s(emoji) + " " + _vm._s(name) + " ")];
      }
    }]),
    model: {
      value: _vm.selectedCountryOption,
      callback: function ($$v) {
        _vm.selectedCountryOption = $$v;
      },
      expression: "selectedCountryOption"
    }
  }), _vm.submitted && _vm.getError('residenceCountry') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" Please select your country of residence ")]) : _vm._e()], 1), _c('div', {
    staticClass: "input-field form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.residenceState,
      expression: "form.residenceState",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.form.residenceState
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "residenceState", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('label', {
    class: _vm.form.residenceState ? 'top-label' : ''
  }, [_vm._v("State / Province"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm.submitted && _vm.getError('residenceState') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" required ")]) : _vm._e()]), _c('div', {
    staticClass: "input-field form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.residenceCity,
      expression: "form.residenceCity",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.form.residenceCity
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "residenceCity", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('label', {
    class: _vm.form.residenceCity ? 'top-label' : ''
  }, [_vm._v("City"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm.submitted && _vm.getError('residenceCity') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" required ")]) : _vm._e()]), _c('div', {
    staticClass: "input-field form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.residenceAddress,
      expression: "form.residenceAddress",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.form.residenceAddress
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "residenceAddress", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('label', {
    class: _vm.form.residenceAddress ? 'top-label' : ''
  }, [_vm._v("Full Residential Address"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm.submitted && _vm.getError('residenceAddress') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" required ")]) : _vm._e()]), _c('div', {
    staticClass: "input-field form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.residencePostalCode,
      expression: "form.residencePostalCode",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.form.residencePostalCode
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "residencePostalCode", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('label', {
    class: _vm.form.residencePostalCode ? 'top-label' : ''
  }, [_vm._v("Postal / ZIP Code")])]), _c('div', {
    staticClass: "text-button-wrap",
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_c('div', {
    staticClass: "custom-control custom-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.residenceAgree,
      expression: "form.residenceAgree"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "id": "residenceAgree",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.residenceAgree) ? _vm._i(_vm.form.residenceAgree, null) > -1 : _vm.form.residenceAgree
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.form.residenceAgree,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "residenceAgree", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "residenceAgree", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "residenceAgree", $$c);
        }
      }
    }
  }), _vm._m(2)]), _vm.submitted && !_vm.form.residenceAgree ? _c('small', {
    staticClass: "text-danger ml-4"
  }, [_vm._v("Please agree to the terms and conditions")]) : _vm._e()])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "top-label"
  }, [_vm._v("Contact Number"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', [_vm._v("Country of Residence"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "custom-control-label text-12 mt-3 terms-condition-label",
    attrs: {
      "for": "residenceAgree"
    }
  }, [_vm._v(" By clicking Submit, I agree to the "), _c('a', {
    attrs: {
      "href": "https://mywhoosh.com/ruleset/",
      "target": "_blank"
    }
  }, [_vm._v("Ruleset")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "https://mywhoosh.com/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_vm._v("Terms and Conditions")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://mywhoosh.com/privacy-policy/",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Notice")]), _vm._v(". ")]);
}]

export { render, staticRenderFns }